var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'row-area-style': !_vm.nonClass},on:{"click":function($event){return _vm.$emit('edit')}}})}
var staticRenderFns = []

export { render, staticRenderFns }